import React from 'react';

export const dashBoardConfigs = [
  {
    auth: ['user'],
    routes: [
      {
        path: '/dashboard',
        component: React.lazy(() => import('./Dashboard')),
      },
    ],
  },
];
